import { BrowserNotificationsActions, } from '../constants';
export const INITIAL_STATE = {
    notificationsStatus: null,
    isUpdating: false,
    error: '',
};
export const browserNotificationsReducers = (state = INITIAL_STATE, action) => {
    const { type, payload } = action;
    switch (type) {
        case BrowserNotificationsActions.UPDATE_STATUS: {
            return {
                ...state,
                notificationsStatus: payload.status,
            };
        }
        case BrowserNotificationsActions.SET_IS_UPDATING: {
            return {
                ...state,
                isUpdating: payload.isUpdating,
            };
        }
        case BrowserNotificationsActions.SET_ERROR: {
            return {
                ...state,
                error: payload.error,
            };
        }
        case BrowserNotificationsActions.CLEAR_ERROR: {
            return {
                ...state,
                error: INITIAL_STATE.error,
            };
        }
        default:
            return state;
    }
};
